<template>
    <a-modal :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose" :width="800">
        <a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <div class="hidden">
                <a-form-item name="id">
                    <a-input v-model:value="form.id" placeholder="请输入id"/>
                </a-form-item>
                <a-form-item name="type">
                    <a-input v-model:value="form.type" placeholder="请输入类型"/>
                </a-form-item>
            </div>
            <a-form-item label="技术中心名称" name="name">
                <a-input v-model:value="form.name" placeholder="请输入技术中心名称"/>
            </a-form-item>
            <a-row :gutter="24">
                <a-col :span="12">
                    <a-form-item label="技术中心办公地址" name="address">
                        <a-input v-model:value="form.address" placeholder="请输入技术中心办公地址"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="技术中心认定时间" name="attestationTime">
                        <DatePicker v-model:value="form.attestationTime" placeholder="请输入技术中心认定时间" style="width: 100%"/>
                    </a-form-item>
                </a-col>
            <a-col :span="12">
                <a-form-item label="研究方向" name="researchDirection">
                    <a-input v-model:value="form.researchDirection" placeholder="研究方向"/>
                </a-form-item>
            </a-col>
            <a-col :span="12">
                <a-form-item label="固定科研人员数量" name="totalStaff">
                    <a-input-number v-model:value="form.totalStaff" :min="0" :precision="0" style="width: 100%" placeholder="固定科研人员数量"/>
                </a-form-item>
            </a-col>
            </a-row>

            <a-row :gutter="24">
                <a-col :span="12">
                    <a-form-item label="负责人" name="headName">
                        <a-input v-model:value="form.headName" :min="0" :precision="0" style="width: 100%" placeholder="负责人"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="负责人联系电话" name="headPhone">
                        <a-input v-model:value="form.headPhone" :min="0" :precision="0" style="width: 100%" placeholder="负责人联系电话"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="联系人" name="contacts">
                        <a-input v-model:value="form.contacts" :min="0" :precision="0" style="width: 100%" placeholder="联系人"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="联系人电话" name="contactsPhone">
                        <a-input v-model:value="form.contactsPhone" :min="0" :precision="0" style="width: 100%" placeholder="联系人电话"/>
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="合作单位，多个用逗号隔开" name="cooperationUnit">
                        <a-textarea v-model:value="form.cooperationUnit" placeholder="请输入合作单位，中间用英文','隔开"
                                    :auto-size="{minRows:3,maxRows:5}"/>
                    </a-form-item>
                </a-col>
            </a-row>
            <!--可编辑区域 end-->
        </a-form>
    </a-modal>
</template>
<script>
import {formMixin} from "@/mixins";
// import dataCheck from "@/utils/dataCheck";
import {ScientificApi} from "@/api/innovationService";
import {companyOriginInfo} from "@/api/tenantService";
import DatePicker from "@/components/form/datePicker/DatePicker";

export default {
    name: "addOrEditModal",
    mixins: [formMixin],
    components: {DatePicker},
    data() {
        return {
            options: [],
            /*表单绑定值与验证规则定义*/
            form: {
                id: null,
                cooperationUnit: null,
                name: null,
                totalStaff: null,
                researchDirection: null,
                attestationTime: null,
                type: null,
                contacts: null,
                contactsPhone: null,
                address: null,
                headName: null,
                headPhone: null,
            },
            rules: {
                id: [],
                cooperationUnit: [],
                name: [],
                totalStaff: [],
                researchDirection: [],
                attestationTime: [],
                type: [],
                contacts: [],
                contactsPhone: [],
                address: [],
                headName: [],
                headPhone: [],
            },
            /*提交表单地址*/
            submitUrl: ScientificApi.saveOrUpdate
        }
    },
    mounted() {
        this.getCompany()
    },
    methods: {
        filterOption(input, option) {
            return (
                option.children[0].children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
        getCompany() {
            this.getAction({
                url: companyOriginInfo.List
            }).then(res => {
                this.options = res
            })
        }
    },
}
</script>
<style scoped lang="less">

</style>
